module.exports = __webpack_public_path__ + "img/15.5d37c7d9.png";